<div class="flex flex-col items-center gap-0">
  <div [innerHTML]="svg()"></div>
  <h1 class="mt-2 text-neutral-400 text-2x font-bold text-center">{{ preview().title }}</h1>
  <div class="flex mt-1 items-center text-neutral-300 text-sm font-normal">
    {{ preview().placeholder[0] }}
    @if (hasAiPermissions()) {
      {{ preview().placeholder[1] }}
      @if (preview().action !== null) {
        <flx-ai-action-button
          (clicked)="preview().action()"
          class="ml-2 mr-2 pointer-events-auto"
          label="Generate"
          flavor="dark"
          iconName="stars-flowx-yellow"
          data-testid="ai-generate-button"
        />
      }
    }
  </div>
  @if (hasAiPermissions()) {
    <div class="text-neutral-300 text-sm font-normal">
      {{ preview().placeholder[2] }}
    </div>
  }
</div>
